import {
  Outlet, useOutletContext, useParams,
} from 'react-router-dom';
import { RoutingContextType } from '.';
import { TasksProvider } from '../contexts/tasks';

export function TasksRoutes() {
  const outletValue: RoutingContextType = useOutletContext();

  const { id } = useParams() as { id: string };

  const contextValue: RoutingContextType = {
    ...outletValue,
  };

  return (
    <TasksProvider id={id}>
      <Outlet context={contextValue} />
    </TasksProvider>
  );
}
